export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-white pt-10 md:pt-12 pb-8 md:pb-10 px-4 md:px-6">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between gap-8">
        <div>
          <h3 className="text-lg font-semibold mb-3 font-heading">Singapore</h3>
          <p className="text-sm text-foreground-300 leading-relaxed">
            6 EU TONG SEN STREET
            <br />
            #12-12 THE CENTRAL
            <br />
            SINGAPORE 059817
          </p>
        </div>
        <div className="flex items-end justify-end">
          <button
            onClick={scrollToTop}
            className="w-10 h-10 flex items-center justify-center border border-white/30 rounded hover:bg-white/10 transition-colors"
            aria-label="Scroll to top"
          >
            <i className="ri-arrow-up-line text-white w-4 h-4 flex items-center justify-center"></i>
          </button>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-8 pt-4 border-t border-white/15 text-center">
        <p className="text-xs text-foreground-400">
          Copyright &copy; {currentYear} Audacious Quest Pte Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}